import { useAnnouncementDetails, useEditAnnouncementForm } from '@/app/pages/notifications/announcements/core/_hooks';
import AnnouncementFormDialog from '@/app/pages/notifications/announcements/modal/AnnouncementFormDialog';

type EditAnnouncementModalProps = {
  show: boolean;
  onClose: () => void;
  announcementId?: string;
};

function EditAnnouncementModal({ show, onClose, announcementId }: EditAnnouncementModalProps) {
  const {
    data: announcement,
    isPending: isLoadingAnnouncement,
    isError: hasLoadFailed,
  } = useAnnouncementDetails(announcementId, show);
  // Falha ao carregar não some com o modal: bloqueia Salvar em vez de mandar o formulário vazio.
  const isDraftUnavailable = Boolean(announcementId) && (isLoadingAnnouncement || hasLoadFailed);

  const { formik, isSaving, isPublishing, saveDraft, publishNow } = useEditAnnouncementForm(
    announcementId,
    announcement,
    onClose,
  );

  return (
    <AnnouncementFormDialog
      formik={formik}
      isPublishing={isPublishing}
      isSaveBlocked={isDraftUnavailable}
      isSaving={isSaving}
      show={show}
      sourceId={announcementId}
      title="Editar rascunho"
      onClose={onClose}
      onPublish={publishNow}
      onSaveDraft={saveDraft}
    />
  );
}

export default EditAnnouncementModal;
